import React from 'react';
import { Container, Row, Col, Card, Image, Button } from 'react-bootstrap';
import { FaLinkedin, FaEnvelope, FaYoutube, FaLink } from 'react-icons/fa';
import profilePic from '../../assets/images/profilePic.jpeg';

const Developers = () => {
  return (
    <Container className="py-5">
      <h1 className="text-center mb-5">Developers</h1>
      
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="shadow-lg">
            <Card.Body className="p-4">
              <div className="text-center mb-4">
                <Image 
                  src={profilePic} 
                  alt="Ayush Gupta"
                  roundedCircle
                  style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                  className="mb-3"
                />
                <h3>Ayush Gupta</h3>
                <p className="text-muted mb-1">Project Lead</p>
                <p className="text-muted">BITS P'27 | GSoC'25@kubeflow</p>
                <div className="d-flex justify-content-center gap-2 mb-4 flex-wrap">
                  <Button 
                    variant="primary" 
                    size="sm"
                    href="https://www.linkedin.com/in/ayush-gupta-a69019280/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedin className="me-2" />
                    LinkedIn
                  </Button>
                  <Button 
                    variant="danger" 
                    size="sm"
                    href="https://www.youtube.com/@Madmecodes"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaYoutube className="me-2" />
                    YouTube
                  </Button>
                  <Button 
                    variant="info" 
                    size="sm"
                    href="https://bio.link/madmecodes"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLink className="me-2" />
                    All Links
                  </Button>
                  <Button 
                    variant="secondary" 
                    size="sm"
                    href="mailto:buildshift.org@gmail.com"
                  >
                    <FaEnvelope className="me-2" />
                    Email
                  </Button>
                </div>
              </div>
              
              <Card className="bg-light">
                <Card.Body>
                  <h4 className="mb-3">Note From Developer</h4>
                  <p className="mb-3">
                    This project is really close to my heart. As a passionate developer and DevOps enthusiast, automating things has always been my goal. When this project came to me, I was genuinely excited. It didn't just test my frontend and backend skills, but also challenged my project management abilities — asking the right questions, understanding the entire flow, and finally coming up with a solution.
                  </p>
                  <p className="mb-3">
                    It wasn't as easy as it sounds — there were several revisions — but in the end, everything aligned perfectly.
                  </p>
                  <p className="mb-4">
                    Now, let's automate that tedious Excel workflow with advanced algorithms, customizable scheduling, and intelligent swapping!
                  </p>
                  <hr />
                  <p className="mb-0 text-center">
                    <small>
                      Found any bug or want to request any feature, please email at{' '}
                      <a href="mailto:buildshift.org@gmail.com">buildshift.org@gmail.com</a>
                    </small>
                  </p>
                </Card.Body>
              </Card>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Developers;